import { createContext } from 'react';

export const currentVideoContext = createContext({
  currentVideo: {},
  setCurrentVideo: () => {},
  playing: false,
  setPlaying: () => {},
  percent: 0,
  setPercent: () => {},
  autoplay: 0,
  setAutoplay: () => {},
  videoState: null,
  setVideoState: () => {}
});
